import {inject, Pipe, PipeTransform} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';

@Pipe({
  name: 'provider',
  standalone: false,
})
export class ProviderPipe implements PipeTransform {
  private readonly translate = inject(TranslateService);

  transform(value: unknown): string {
    if (value === null || value === undefined || value === '') {
      return this.translate.instant('common.unknown');
    }
    const slug = String(value).trim().toLowerCase();

    if (!slug) {
      return this.translate.instant('common.unknown');
    }
    const key = `enums.paymentProvider.${slug}`;
    const translated = this.translate.instant(key);
    if (!translated || translated === key) {
      return this.translate.instant('common.unknown');
    }
    return translated;
  }
}
